
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ProductionItemsGrid extends Serenity.EntityGrid<ProductionItemsRow, any> {
        protected getColumnsKey() { return 'Production.ProductionItems'; }
        protected getDialogType() { return ProductionItemsDialog; }
        protected getIdProperty() { return ProductionItemsRow.idProperty; }
        protected getInsertPermission() { return ProductionItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductionItemsRow.localTextPrefix; }
        protected getService() { return ProductionItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}